<template>
    <div class="portalNav_box">
        <div class="portalNav_body_box">
            <div class="portalNav_top_box">
                <div class="portalNav_header_box">
                    <div class="portalNav_header_iconBox" @click="toPersonSetPage">
                        <!-- <div class="portalNav_header_icon">
                            {{ (sessionMap['emp_name'] || '').slice(-1) }}
                        </div> -->
                        <avatarMenu :isShowName="false" :noShowOther="true"></avatarMenu>
                    </div>
                </div>
                <div class="portalNav_navItem_box">
                    <el-scrollbar height="100%">
                        <div v-for="item,index of returnNavList()" :key="index" 
                    :draggable="true"
                    @dragstart="dragstart(item)"
                    @dragover="dragover($event,item)">
                            <selfBuildAppMenu v-if="item['key'] == 'zjyy'" :sence="'nav'">
                                <template #iconSlot>
                                    <div class="portalNav_navItem_item" :class="actNav == item.key ?'portalNav_navItem_item_act':''">
                                        <el-badge :value="unreadNumObj[item.key] ? ((unreadNumObj[item.key]) || undefined) : undefined" :max="99">
                                            <div class="portalNav_navItem_item_icon">
                                                <img :src="actNav == item.key ? item.iconAct : item.icon" alt="" srcset="">
                                            </div>
                                        </el-badge>
                                        <div class="portalNav_navItem_item_name">{{ item.name }}</div>
                                    </div>
                                </template>
                            </selfBuildAppMenu>
                            <div v-else class="portalNav_navItem_item" @click="changeActTab(item)"  :class="actNav == item.key ?'portalNav_navItem_item_act':''">
                                <el-badge :value="unreadNumObj[item.key] ? ((unreadNumObj[item.key]) || undefined) : undefined" :max="99">
                                    <div class="portalNav_navItem_item_icon">
                                        <img :src="actNav == item.key ? item.iconAct : item.icon" alt="" srcset="">
                                    </div>
                                </el-badge>
                                <div class="portalNav_navItem_item_name">{{ item.name }}</div>
                            </div>
                        </div>

                    </el-scrollbar>
                </div>
            </div>
            <div class="portalNav_bottom_box">
                <el-dropdown placement="top-start" style="width:100%" trigger="click">
                    <div class="portalNav_bottom_btn">
                        <i class="iconfont icon-shezhi1"></i>
                    </div>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item v-for="item,index of moreList" :key="index" @click="changeActTab(item)">
                                <div style="display: flex;align-items: center;padding: 4px 0;min-width: 120px;">
                                    <div :style="{'background-image':item.background,'box-shadow':item.boxShadow}" style="width: 24px;height: 24px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 6px;">
                                        <img :src="item.img" alt="" style="width: 14px;">
                                    </div>
                                    <span>{{ item.name }}</span>
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item @click="checkUpload()" :divided="moreList.length > 0">
                                <div style="display: flex;align-items: center;min-width: 120px;">
                                    <div style="width: 24px;height: 24px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 6px;">
                                        <i class="iconfont icon-shengji1" style="color:#EE822F;font-size: 14px;"></i>
                                    </div>
                                    <span>检查更新</span>
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item @click="logout()" divided>
                                <div style="display: flex;align-items: center;min-width: 120px;">
                                    <div style="width: 24px;height: 24px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 6px;">
                                        <i class="iconfont icon-anquantuichu" style="color:#df465d;font-size: 14px;"></i>
                                    </div>
                                    <span>安全退出</span>
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
  
<script>

import avatarMenu from "./menu/avatarMenu.vue"
  import selfBuildAppMenu from "../selfBuildApp/selfBuildAppMenu.vue"
export default {
    components: {
        selfBuildAppMenu,
        avatarMenu
    },
    props: {
        modelValue: {
            type: String,
            default: function () {
                return '';
            },
        },
        navList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        moreList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        unreadNumObj: {
            type: Object,
            default: function () {
                return {};
            },
        },
        sessionMap: {
            type: Object,
            default: function () {
                return {
                    emp_name:''
                };
            },
        },
    },
    watch: {
        modelValue: {
            handler(newVal) {
                this.actNav = newVal
            },
            deep: true,
            immediate: true
        },
    },
    data() {
      return {
        actNav:'',
        navCstList:['talkPortal','contact','pExam','rl','zsb','yx','rw','gzt','zjyy','ai','yxt','lct'],
        moreListData:[],
        dragConfig:{
            starItem:null, 
            endItem:{}, 
            pos:null
        },
      };
    },
  
    created() {
        
    },
    mounted() {
        this.reSetBuildList()
    },
    methods: {
        reSetBuildList(){
            let list = JSON.parse(localStorage.getItem('deskList') || '[]')
            if(list.length > 0){
                this.navCstList = list;
            }
        },
        returnNavList(){
            let navList = this.navList
            navList = navList.sort((a,b)=>{
                let aIndex = this.navCstList.indexOf(a.key)
                let bIndex = this.navCstList.indexOf(b.key)
                if(aIndex > bIndex){
                    return 1
                }
                else{
                    return -1
                }
            })
            return navList;
        },
        changeActTab(item){
            if(this.actNav == item.key){
                this.$emit('initVal',item)
            }
            else{
                this.actNav = item.key
                this.$emit('update:modelValue',this.actNav)
                this.$emit('changeVal',item)
            }
        },
        toPersonSetPage(){
            this.$router.push('/user/userInfo')
        },
        logout(){
            this.$http.post(this.$api.org.user.logout, {}).then(() => {
                localStorage.removeItem('autoLoginSet')
                this.$session.delSession();
                this.$router.push('/pub/pswdLogin')
            }).catch(() => {
                localStorage.removeItem('autoLoginSet')
                this.$session.delSession();
                this.$router.push('/pub/pswdLogin')
            })

        },
        checkUpload(){
            const { ipcRenderer } = require('electron')
            ipcRenderer.send('checkForUpdatesAndNotify')
        },
        dragstart(item){
            this.dragConfig.starItem = {...item}
            document.addEventListener("dragend",this.dragend)
        },
        dragover(e,item){
            e.preventDefault();
            this.dragConfig.endItem = {...item}
            this.dragConfig.pos = e.offsetY < (e.target.clientHeight/2) ? 'top':'bottom'
        },
        dragend(){
            document.removeEventListener("dragend",this.dragend)
            if(!this.dragConfig.starItem.key || !this.dragConfig.endItem.key){
                this.dragConfig ={
                    starItem:null,
                    endItem:{},
                    pos:null,
                }
                return
            }
            if(this.dragConfig.starItem.key == this.dragConfig.endItem.key){
                this.dragConfig ={
                    starItem:null,
                    endItem:{},
                    pos:null,
                }
                return
            }
            let olArr = [
                {
                    ...this.dragConfig.starItem,
                },
                {
                    ...this.dragConfig.endItem,
                },
            ]
            if(this.dragConfig.pos == 'bottom'){
                olArr.reverse();
            }
            let copyList = JSON.parse(JSON.stringify(this.returnNavList()))
            let newArr = copyList.filter(zitem=>{return zitem.key != this.dragConfig.starItem.key})
            let resArr = newArr.reduce((res = [],item)=>{
                if(item.key == this.dragConfig.endItem.key){
                    let obj1 = olArr[0].key
                    res.push(obj1)
                    let obj2 = olArr[1].key
                    res.push(obj2)
                }
                else{
                    let obj = item.key
                    res.push(obj)
                }
                return res
            },[])
            this.navCstList = JSON.parse(JSON.stringify(resArr))
            this.toSetBuildList()
        },
        toSetBuildList(){
            localStorage.setItem('deskList',JSON.stringify(this.navCstList))
        },
    },
};
</script>
<style lang="scss" scoped>
.portalNav_box{
    width: 100%;
    height: 100%;
    background: var(--navImage);
    .portalNav_body_box{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 6px;
        box-sizing: border-box;
        height: 100%;
        .portalNav_top_box{
            flex-grow: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .portalNav_header_box{
                display: flex;
                flex-wrap: wrap;
                flex: 0 0 auto;
                padding: 10px 0 16px 0;
                overflow: hidden;
                cursor: pointer;
                .portalNav_header_iconBox{
                    width: 32px;
                    height: 32px;
                    flex: 0 0 auto;
                    box-sizing: border-box;
                    border-radius: 6px;
                    margin: 0 auto;
                    color: #fff;
                    position: relative;
                    :deep(.user-name){
                        width: 28px!important;
                        height: 28px!important;
                    }
                    .portalNav_header_icon{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(312.6deg, #3370FF 26.86%, #45C7FF 97.63%);
                        position: relative;
                        border-radius: 6px;
                        font-size: 12px;
                    }
                    &::before{
                        content: '';
                        position: absolute;
                        top: -1px;
                        left: -1px;
                        width: calc(100% + 2px);
                        height: calc(100% + 2px);
                        background: #FFFFFF40;
                        border-radius: 6px;
                    }
                }
                .portalNav_header_name{
                    color: #ffffff65;
                    text-align: center;
                    flex-grow: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: center;
                    line-height: 28px;
                }
            }
            .portalNav_navItem_box{
                flex-grow: 1;
                overflow: hidden;
                .portalNav_navItem_item{
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    color: #ffffff65;
                    padding: 8px 0;
                    transition: all 0.25s;
                    cursor: pointer;
                    border-radius: 6px;
                    box-sizing: border-box;
                    margin-bottom: 6px;
                    &:hover{
                        background: #DBE6FF26; 
                    }
                    .portalNav_navItem_item_icon{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        img{
                            width: 18px;
                            height: 18px;
                        }
                    }
                    .portalNav_navItem_item_name{
                        flex-grow: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        font-size: 12px;
                        line-height: 12px;
                        margin-top: 6px;
                        color: #FFFFFFA6;
                        transition: all 0.25s;
                    }
                    :deep(.el-badge__content--danger){
                        pointer-events: none;
                    }
                    :deep(.el-badge__content){
                        padding: 0 4px;
                        min-width: 14px;
                        --el-color-danger:red;
                        line-height: 18px;
                        border: none;
                        zoom: 0.85;
                        margin-top:3px;
                        font-size:12px;
                    }
                }
                .portalNav_navItem_item_act{
                    background: #DBE6FF26;
                    .portalNav_navItem_item_name{
                        color: #fff;
                    }
                }
            }
        }
        .portalNav_bottom_box{
            width: 100%;
            padding: 12px 0;
            .portalNav_bottom_btn{
                color: #ffffff90;
                display: flex;
                justify-content: center;
                cursor: pointer;
                width: 100%;
                i{
                    font-size: 18px;
                }
            }
        }
    }
}
</style>